import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCROLL_KEY_PREFIX = "sg7_scroll_";

function getKey(pathname: string, search: string) {
  return SCROLL_KEY_PREFIX + pathname + search;
}

/**
 * Saves scroll position on unmount/navigation and restores it on mount.
 * Works with browser back/forward to preserve list position.
 */
export function useScrollRestore() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const key = getKey(pathname, search);

    // Restore scroll position after content has rendered
    const saved = sessionStorage.getItem(key);
    if (saved) {
      const scrollY = parseInt(saved, 10);
      // Use double rAF to wait for layout + paint
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
        });
      });
    }

    // Save scroll position on unmount
    return () => {
      sessionStorage.setItem(key, String(window.scrollY));
    };
  }, [pathname, search]);
}
